import produce from "immer";
import { AnyAction } from "redux";
import { initialStateType } from "./types";
import { AppConstants } from "./constants";
import { AVAILABLE_LANGUAGES, getEnvVariable } from "utils/environment";

const availableLanguages = getEnvVariable(AVAILABLE_LANGUAGES).split(",");

const initialState: initialStateType = {
    language: availableLanguages[0] || "en",
    theme: "dark",
    isOpenPreferencesModal: false,
    tenant: null
};

const AppReducer = (state = initialState, action: AnyAction) =>
    produce(state, (draft) => {
        switch (action.type) {
            case AppConstants.UPDATE_LANGUAGE: {
                if (availableLanguages.includes(action.payload)) {
                    draft.language = action.payload;
                } else {
                    draft.language = availableLanguages[0] || "en";
                }
                break;
            }
            case AppConstants.UPDATE_THEME:
                draft.theme = action.payload;
                break;
            case AppConstants.IS_OPEN_PREFERENCES_MODAL:
                draft.isOpenPreferencesModal = action.payload;
                break;
            case AppConstants.UPDATE_TENANT:
                draft.tenant = action.payload;
                break;
            default:
                return state;
        }
    });

export default AppReducer;
